module.exports = __webpack_public_path__ + "static/media/logo---inverted.4e7881d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/images/logo---inverted.svg
// module id = 654
// module chunks = 0